module.exports = __webpack_public_path__ + "img/ExitIcon.9bea50b2.svg";